import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import FormUploadBox from '../upload-box';
import styles from './index.module.css';
import { ReactComponent as RemoveIcon } from './remove.svg';
import { ReactComponent as UploadIcon } from './upload.svg';

function FormImageUpload(props: {
  className?: string;
  onChange: (value?: string) => void;
  value?: string;
  disabled?: boolean;
  removable?: boolean;
}) {
  const { t } = useTranslation('common');

  async function onUpload(file: File) {
    // const reader = new FileReader();
    // reader.onload = (e) => {
    //   const result = e.target!.result as string;
    //   setImage(result);
    //   props.onChange(result);
    // };
    // reader.readAsDataURL(file);

    const url = URL.createObjectURL(file);
    props.onChange(url);
  }

  let content;

  if (props.value) {
    content = (
      <div className={clsx('group', styles['image-container'])}>
        <img src={props.value} className="w-full block" />
        <div className="absolute left-0 top-0 w-full h-full opacity-0 group-hover:opacity-100 transition duration-200 flex flex-col justify-center items-center bg-black bg-opacity-50 text-white text-sm font-light">
          <UploadIcon />
          <span className="mt-1 text-center">{t('uploadImage')}</span>
        </div>
        {props.removable && (
          <div
            className="absolute right-2 top-2 opacity-0 group-hover:opacity-100 "
            onClick={onRemove}
          >
            <RemoveIcon />
          </div>
        )}
      </div>
    );
  }

  function onRemove(event: any) {
    event.preventDefault();
    event.stopPropagation();

    props.onChange(undefined);
  }

  return (
    <FormUploadBox
      className={props.className}
      fileTypes={['png']}
      onUpload={onUpload}
      content={content}
      disabled={props.disabled}
    />
  );
}

export default FormImageUpload;
